import { IBlockInstanceModel } from './block.model'

export interface ILessonModel {
  id?: number
  name: string
  description?: string
  order: number
  blockInstances?: IBlockInstanceModel[]
  courseId?: number
}

export const lessonInitialStore: ILessonModel = {
  name: '',
  description: '',
  order: 0,
  blockInstances: [],
}
